import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { getCartsByParams } from '@nike/ux-tread-cart';
import { SERVICE_FETCH_CART_CARTS, MISSING_VALUES } from '@nike/cart-constants';
import { DOTCOM_UX_ID, NIKECOM_CHANNEL, NIKE_BRAND } from '@nike/ux-tread-dotcom-constants';
import handleCartErrors from './handle-cart-errors';
import { onInitCart, onFetchSuccess } from './action-creators';

/**
 * fetchCart proxies api request to either carts
 *
 * @param {object} params - named parameters
 * @param {string} params.appId - app specific id used with unite config
 * @param {string} [params.brand=NIKE_BRAND] - brand is a differentiation for carts, by default it's set to NIKE
 * @param {string} [params.channel=NIKECOM_CHANNEL] - channel is a differentiation for carts, by default it's set to NIKECOM
 * @param {string} params.country - country code
 * @param {string} params.cloudStack - cloud_stack header to pass along to ux-tread-cart
 * @param {string} params.langLocale - language locale
 * @param {string} params.language -   language in cloud url format
 * @param {string} params.localeForCurrency -   - BCP 47 language tag - ux-tread-localization/getLocaleForCurrencyFormatting
 * @param {string} params.merchGroup - locale specific information
 * @param {string} params.token - unite authToken
 * @param {string} params.visitId - visit id
 * @param {string} params.visitorId - visitor id
 * @param {string} params.host - host name to use when calling cart service
 *
 * @returns {Promise} thenable return with dispatched action results
 */
export default function fetchCart() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$appId = _ref.appId,
    appId = _ref$appId === void 0 ? DOTCOM_UX_ID : _ref$appId,
    country = _ref.country,
    _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? NIKE_BRAND : _ref$brand,
    _ref$channel = _ref.channel,
    channel = _ref$channel === void 0 ? NIKECOM_CHANNEL : _ref$channel,
    cloudStack = _ref.cloudStack,
    merchGroup = _ref.merchGroup,
    token = _ref.token,
    visitId = _ref.visitId,
    visitorId = _ref.visitorId,
    host = _ref.host;
  return function (dispatch) {
    if (!(visitorId || token) || !country) {
      return Promise.resolve().then(function () {
        return dispatch({
          type: MISSING_VALUES,
          payload: {
            visitId: visitId,
            visitorId: visitorId,
            token: token,
            country: country
          }
        });
      });
    }
    var service = SERVICE_FETCH_CART_CARTS;
    var params = {
      host: host,
      cloudStack: cloudStack,
      brand: brand,
      channel: channel,
      appId: appId,
      token: token,
      visitId: visitId,
      visitorId: visitorId,
      country: country
    };
    dispatch(onInitCart(_objectSpread({
      service: service,
      country: country,
      merchGroup: merchGroup,
      appId: appId,
      cloudStack: cloudStack
    }, params)));
    return getCartsByParams(params).then(function (payload) {
      return dispatch(onFetchSuccess(_objectSpread({
        service: service
      }, payload)));
    }, function (error) {
      return dispatch(handleCartErrors({
        service: service,
        params: params,
        error: error
      }));
    });
  };
}